import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../store/hooks';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../components/card/card';
import { Form } from 'react-bootstrap';
import EquipmentsOdometerList from './EquipmentsOdometerList';
import {
  // GetEquipmentsOdometerList,
  InsertEquipmentsOdometer,
  GetEquipmentsOdometerListByFleetEquipmentsId
} from '../../../store/FLEET/EquipmentsOdometer/equipmentsOdometerSlice';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import EditEquipmentsOdometer from './EditEquipmentsOdometer';
import ModalComponent from '../../../components/Modal/ModalComponent';
import { EquipmentsOdometerSchema } from '../../ValidationForm/validationSchema';
import useGetPeoplesList from '../../../hooks/NTX/useGetPeoplesList';
import Loading from '../../../components/Shared/Loader/Loading';

import useGetDriversList from '@hooks/FLeet/useGetDriversList';
import Select from 'react-select';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const EquipmentsOdometer = () => {
  const { HasPermission } = usePermissions();
  const [ID, setID] = useState<string>(''); // لتعريفة من مكون القائمة ومن ثم استعماله في مكون التعديل
  const { Id } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const { OptionsDrivers, loading: loading1, error: error1 } = useGetDriversList();

  useEffect(() => {
    if (Id) {
      dispatch(GetEquipmentsOdometerListByFleetEquipmentsId(Id));
    }
  }, [Id]);

  const formik = useFormik({
    initialValues: {
      fleetEquipmentsId: Id,
      peopleId: '',
      odometer: 0,
      readDate: '',
      description: ''
    },
    validationSchema: EquipmentsOdometerSchema(t),
    onSubmit: values => {
      dispatch(
        InsertEquipmentsOdometer({
          fleetEquipmentsId: values.fleetEquipmentsId,
          peopleId: values.peopleId,
          odometer: values.odometer,
          description: values.description,
          readDate: values.readDate
        })
      )
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            if (Id) {
              dispatch(GetEquipmentsOdometerListByFleetEquipmentsId(Id));
            }
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });
  //____

  const reference = JSON.parse(localStorage.getItem('ReferenceName') || '{}');

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Assets_and_Equipment',
              link: '/FLEET/Equipments'
            },
            {
              name: 'Odometer',
              link: null
            }
          ]}
          PageName='Odometer'
          subtitle={reference?.plateNo}
        />

        <div className='ms-auto'>
          <Link to='/FLEET/Equipments' replace className='btn me-1 btn-secondary '>
            <i className='fa fa-arrow-left me-2'></i>
            {t('Back')}
          </Link>
        </div>
      </div>

      {HasPermission('FleetAddEquipmentOdometer') && (
        <Card className='shadow'>
          <Loading loading={loading1}>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <div className='row mb-4'>
                  <div className='col-md-6 mt-3'>
                    <div className='input-group flex-nowrap'>
                      <span className='input-group-text     fw-bold'>
                        <i className='fas fa-user	 me-2'></i>
                        {t('Driver')}
                      </span>
                      <Select
                        classNamePrefix='react-select'
                        className='w-100  '
                        // isLoading={loading}
                        isSearchable={true}
                        isClearable
                        options={OptionsDrivers}
                        placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                        onChange={(option: any) => formik.setFieldValue('peopleId', option.value)}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                        formatOptionLabel={option => (
                          <div className='d-flex justify-content-between   '>
                            <div className=''>
                              {option.hasVehicle && (
                                <i className='fas fa-car text-theme me-2' title={t('AssignedVehicle')}></i>
                              )}
                              {option.label}
                            </div>
                            <div className='text-theme fw-bold'>{option.personNo}</div>
                          </div>
                        )}
                        filterOption={({ label, data }, input) => {
                          const searchValue = input?.toLowerCase();
                          return (
                            label?.toLowerCase().includes(searchValue) ||
                            data.personNo?.toLowerCase().includes(searchValue)
                          );
                        }}
                      />
                    </div>
                    {formik.errors.peopleId && formik.touched.peopleId && (
                      <div style={{ color: 'red' }}>{formik.errors.peopleId}</div>
                    )}
                  </div>

                  <div className='col-md-3 mt-3'>
                    <div className='input-group flex-nowrap'>
                      <span className='input-group-text   fw-bold'>
                        <i className=' fa-fw bi bi-speedometer fa-lg	 me-2'></i>
                        {t('Odometer')}
                      </span>
                      <Form.Control
                        type='number'
                        name='odometer'
                        value={formik.values.odometer}
                        onChange={formik.handleChange}
                        className='form-control '
                      />
                    </div>
                    {formik.errors.odometer && formik.touched.odometer && (
                      <div style={{ color: 'red' }}>{formik.errors.odometer}</div>
                    )}
                  </div>

                  <div className='col-md-3 mt-3'>
                    <div className='input-group flex-nowrap'>
                      <span className='input-group-text   fw-bold'>
                        <i className='far fa-calendar-alt	 me-2'></i>
                        {t('DateOfReading')}
                      </span>
                      <Form.Control
                        type='datetime-local'
                        name='readDate'
                        value={formik.values.readDate}
                        onChange={formik.handleChange}
                        className='form-control '
                      />
                    </div>
                    {formik.errors.readDate && formik.touched.readDate && (
                      <div style={{ color: 'red' }}>{formik.errors.readDate}</div>
                    )}
                  </div>
                </div>

                <div className='text-center'>
                  <div className='d-flex justify-content-end gap-2'>
                    <button disabled={formik.isSubmitting} type='submit' className='btn   btn-theme mb-1   rounded-0'>
                      {formik.isSubmitting ? (
                        <div className='spinner-border spinner-border-sm me-2'></div>
                      ) : (
                        <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                      )}
                      {t('Add')}
                    </button>
                    {/* <button
                      type='button'
                      className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
                      onClick={() => Navigate('/FLEET/Equipments', { replace: true })}
                    >
                      <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                    </button> */}
                  </div>
                </div>
              </Form>
            </CardBody>
          </Loading>
        </Card>
      )}

      <Card className='mt-3'>
        <Loading loading={loading1}>
          <CardBody>
            <div className=''>
              <EquipmentsOdometerList setID={setID} />
            </div>
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('Update_Odometer')} id='UpdateEquipmentsOdometer' size='lg'>
        {ID && <EditEquipmentsOdometer ID={ID} />}
      </ModalComponent>
    </div>
  );
};

export default EquipmentsOdometer;

// <div className='text-center'>
//   <button
//     disabled={formik.isSubmitting}
//     type='submit'
//     className='btn me-1 btn-theme mb-1'
//     id='SaveSubmit'
//   >
//     {formik.isSubmitting ? (
//       <div className='spinner-border spinner-border-sm me-2'></div>
//     ) : (
//       <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//     )}
//     {t('Add')}
//   </button>
//   <button
//     type='button'
//     className=' btn me-1 btn-default mb-1'
//     onClick={() => Navigate('/FLEET/Equipments', { replace: true })}
//   >
//     <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//   </button>
// </div>
